/* Barra fija de compra — assets/sticky-atc.js */

(function () {
  if (window.customElements.get('sticky-buy-bar')) return;

  var MAIN_FORM = 'form[action*="/cart/add"]';
  var THEME_ADD_BUTTON = '.product-form__add-button:not([disabled])';
  var MINI_CART = '#mini-cart';
  var MINI_CART_TOGGLE = '[data-action="toggle-mini-cart"]';

  class StickyBuyBar extends HTMLElement {
    connectedCallback() {
      this.addBtn = this.querySelector('[data-mrk-add]');
      this.addLabel = this.querySelector('[data-mrk-add-label]');
      this.priceEl = this.querySelector('[data-mrk-price]');
      this.thumbEl = this.querySelector('[data-mrk-thumb]');
      this.statusEl = this.querySelector('[data-mrk-status]');
      this.recsEl = this.querySelector('[data-mrk-recs]');
      this.toggleBtn = this.querySelector('[data-mrk-toggle]');

      this.labels = {
        base: this.dataset.labelDefault || '',
        soldOut: this.dataset.labelSoldout || '',
        adding: this.dataset.labelAdding || '',
        added: this.dataset.labelAdded || '',
        error: this.dataset.labelError || ''
      };

      try {
        this.variants = JSON.parse(this.querySelector('[data-mrk-variants]').textContent);
      } catch (e) {
        this.variants = [];
      }

      this.initReveal();
      this.initVariantSync();
      this.initCartWatch();
      this.bindActions();
      this.loadRecommendations();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.cartObserver) this.cartObserver.disconnect();
    }

    /*
      Mientras el cajon del carrito este abierto, ocultar la barra.
      Si no, en movil tapa los botones "Ver carrito" y "Comprar Ahora".
    */
    initCartWatch() {
      var drawer = document.querySelector(MINI_CART);
      if (!drawer || !('MutationObserver' in window)) return;

      var self = this;
      var apply = function () {
        var open = drawer.getAttribute('aria-hidden') === 'false';
        self.classList.toggle('is-cart-open', open);
      };

      this.cartObserver = new MutationObserver(apply);
      this.cartObserver.observe(drawer, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
      apply();
    }

    /*
      Buscar el bloque de botones de compra real y visible.
      Se descartan formularios ocultos (quick view, plantillas duplicadas)
      porque un elemento sin caja nunca "intersecta" y falsearia el calculo.
    */
    findAnchor() {
      var groups = [
        document.querySelectorAll('.product-form__buy-buttons'),
        document.querySelectorAll(MAIN_FORM)
      ];

      for (var g = 0; g < groups.length; g++) {
        var list = groups[g];
        for (var i = 0; i < list.length; i++) {
          var el = list[i];
          if (el.closest('sticky-buy-bar')) continue;
          if (el.closest(MINI_CART)) continue;
          if (el.offsetParent === null) continue;

          var r = el.getBoundingClientRect();
          if (r.height > 0 && r.width > 0) return el;
        }
      }
      return null;
    }

    /*
      Mostrar la barra solo cuando los botones han quedado ARRIBA del viewport,
      es decir cuando el usuario ya bajo y los dejo atras.
      Estar "fuera de vista" no basta: al cargar en movil los botones suelen
      estar por debajo del pliegue, y eso no debe activar la barra.
    */
    initReveal() {
      var self = this;
      var anchor = this.findAnchor();

      if (!anchor) {
        if (this.anchorTries === undefined) this.anchorTries = 0;
        if (this.anchorTries < 5) {
          this.anchorTries++;
          window.setTimeout(function () {
            self.initReveal();
          }, 300);
          return;
        }

        /* Sin ancla fiable: no aparecer hasta pasar la primera pantalla completa */
        var blind = function () {
          self.classList.toggle('is-shown', window.scrollY > window.innerHeight);
        };
        window.addEventListener('scroll', blind, { passive: true });
        blind();
        return;
      }

      var update = function () {
        var r = anchor.getBoundingClientRect();
        /* bottom < 0 => los botones estan por encima del borde superior */
        self.classList.toggle('is-shown', r.bottom < 0);
      };

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(update, { threshold: 0 });
        this.observer.observe(anchor);
        update();
        return;
      }

      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }

    /* Seguir la variante elegida en el formulario principal */
    initVariantSync() {
      var sync = this.syncVariant.bind(this);
      document.addEventListener('change', sync);
      document.addEventListener('variant:changed', sync);
      document.documentElement.addEventListener('variant:changed', sync);
      sync();
    }

    get selectedId() {
      var input = document.querySelector(MAIN_FORM + ' [name="id"]:not([disabled])');
      if (input && input.value) return parseInt(input.value, 10);
      return this.variants.length ? this.variants[0].id : null;
    }

    get quantity() {
      var qty = document.querySelector(MAIN_FORM + ' [name="quantity"]');
      var value = qty ? parseInt(qty.value, 10) : 1;
      return value > 0 ? value : 1;
    }

    syncVariant() {
      var id = this.selectedId;
      var variant = this.variants.filter(function (v) {
        return v.id === id;
      })[0];
      if (!variant) return;

      if (this.priceEl && variant.price) this.priceEl.textContent = variant.price;
      if (this.thumbEl && variant.image) this.thumbEl.src = variant.image;

      if (this.addBtn) {
        this.addBtn.disabled = !variant.available;
        if (this.addLabel) {
          this.addLabel.textContent = variant.available
            ? this.labels.base
            : this.labels.soldOut;
        }
      }
    }

    /* Abrir el mini-carrito del tema. Es un toggle: solo pulsar si esta cerrado. */
    openMiniCart() {
      var toggle = document.querySelector(MINI_CART_TOGGLE);
      if (!toggle) return false;

      var drawer = document.querySelector(MINI_CART);
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') return true;

      toggle.click();
      return true;
    }

    bindActions() {
      var self = this;

      if (this.addBtn) {
        this.addBtn.addEventListener('click', function () {
          self.addMain();
        });
      }

      if (this.toggleBtn && this.recsEl) {
        this.toggleBtn.addEventListener('click', function () {
          var open = self.toggleBtn.getAttribute('aria-expanded') === 'true';
          self.toggleBtn.setAttribute('aria-expanded', String(!open));
          self.recsEl.hidden = open;
        });
      }

      this.addEventListener('click', function (event) {
        var quick = event.target.closest('[data-mrk-quick-add]');
        if (!quick) return;
        var label = quick.querySelector('span') || quick;
        self.addItem(parseInt(quick.dataset.mrkQuickAdd, 10), 1, quick, label);
      });
    }

    /*
      Boton principal: delega el clic al boton real del tema (<buy-button>).
      Asi el carrito se abre solo, con los descuentos y avisos nativos.
      Si no se encuentra, cae al metodo AJAX.
    */
    addMain() {
      var themeBtn = document.querySelector(MAIN_FORM + ' ' + THEME_ADD_BUTTON);

      if (themeBtn) {
        if (this.addLabel) {
          var original = this.addLabel.textContent;
          this.addLabel.textContent = this.labels.adding;
          var label = this.addLabel;
          window.setTimeout(function () {
            label.textContent = original;
          }, 1200);
        }
        themeBtn.click();
        return;
      }

      this.addItem(this.selectedId, this.quantity, this.addBtn, this.addLabel);
    }

    addItem(id, quantity, button, labelEl) {
      if (!id || !button || button.disabled) return;

      var self = this;
      var original = labelEl ? labelEl.textContent : '';

      button.disabled = true;
      if (labelEl) labelEl.textContent = this.labels.adding;

      fetch(this.dataset.addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [{ id: id, quantity: quantity }] })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add-failed');

          if (labelEl) labelEl.textContent = self.labels.added;
          if (self.statusEl) self.statusEl.textContent = self.labels.added;

          var mode = self.dataset.afterAdd;

          if (mode === 'cart') {
            window.location.href = self.dataset.cartUrl;
            return;
          }
          if (mode === 'reload') {
            window.location.reload();
            return;
          }

          /* Refrescar el contenido del mini-carrito */
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          if (mode === 'drawer') {
            /* Dar tiempo al tema a repintar el carrito antes de abrirlo */
            window.setTimeout(function () {
              if (!self.openMiniCart()) window.location.href = self.dataset.cartUrl;
            }, 350);
          }
        })
        .catch(function () {
          if (labelEl) labelEl.textContent = self.labels.error;
          if (self.statusEl) self.statusEl.textContent = self.labels.error;
        })
        .then(function () {
          window.setTimeout(function () {
            button.disabled = false;
            if (labelEl) labelEl.textContent = original;
          }, 1800);
        });
    }

    /* Recomendaciones vía Section Rendering API */
    loadRecommendations() {
      var url = this.dataset.recsUrl;
      var list = this.querySelector('[data-mrk-recs-list]');
      var self = this;
      if (!url || !list) return;

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var parsed = document.createElement('div');
          parsed.innerHTML = text;
          var fresh = parsed.querySelector('[data-mrk-recs-list]');
          if (fresh && fresh.innerHTML.trim()) {
            list.innerHTML = fresh.innerHTML;
          } else if (self.toggleBtn) {
            self.toggleBtn.hidden = true;
          }
        })
        .catch(function () {
          if (self.toggleBtn) self.toggleBtn.hidden = true;
        });
    }
  }

  window.customElements.define('sticky-buy-bar', StickyBuyBar);
})();
